import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Mail, Clock } from 'lucide-react';
import { clinicData } from '../data';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_54b8577b-aded-44ca-bd61-800fb34bb6e2/artifacts/7wv7dh12_image.png"
              alt="Man Clinics Logo"
              className="h-10 sm:h-12 md:h-14 w-auto object-contain mb-4"
            />
            <h3 className="text-white font-semibold mb-3">{clinicData.name}</h3>
            <p className="text-sm text-gray-400 mb-3">{clinicData.tagline}</p>
            <p className="text-sm text-gray-400">{clinicData.specialties.join(' | ')}</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-[#D91656] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-[#D91656] transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/treatments" className="text-sm hover:text-[#D91656] transition-colors">
                  Our Treatments
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-[#D91656] transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="h-5 w-5 text-[#D91656] mt-0.5 flex-shrink-0" />
                <span className="text-sm">{clinicData.contact.phone}</span>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-[#D91656] mt-0.5 flex-shrink-0" />
                <span className="text-sm">{clinicData.contact.email}</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-[#D91656] mt-0.5 flex-shrink-0" />
                <span className="text-sm">{clinicData.contact.address}</span>
              </li>
              <li className="flex items-start space-x-3">
                <Clock className="h-5 w-5 text-[#D91656] mt-0.5 flex-shrink-0" />
                <span className="text-sm">Available 24/7 for emergencies</span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-white font-semibold mb-4">Newsletter</h4>
            <p className="text-sm text-gray-400 mb-4">
              Subscribe to our newsletter for health tips and updates.
            </p>
            <div className="flex">
              <input
                type="email"
                placeholder="Your Email"
                className="px-4 py-2 w-full rounded-l-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#D91656]"
              />
              <button className="bg-[#D91656] text-white px-4 py-2 rounded-r-lg hover:bg-[#B01348] transition-colors">
                Join
              </button>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} {clinicData.name}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
